

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETADMINDASHBOARDBYYEAR= createAsyncThunk(
  "getAdminDashboardByYear/getAdminDashboardByYear",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAdminDashboardByYearSlice = createSlice({
  name: "getAdminDashboardByYearSlice",
  initialState: {
    getAdminDashboardByYear: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAdminDashboardByYear: (state) => {
        state.getAdminDashboardByYear.loading = false
        state.getAdminDashboardByYear.error = false
        state.getAdminDashboardByYear.data = []
        state.getAdminDashboardByYear.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETADMINDASHBOARDBYYEAR.fulfilled, (state, action) => {
      state.getAdminDashboardByYear = {
        ...state.getAdminDashboardByYear,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINDASHBOARDBYYEAR.pending, (state, action) => {
      state.getAdminDashboardByYear = {
        ...state.getAdminDashboardByYear,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETADMINDASHBOARDBYYEAR.rejected, (state, action) => {
      state.getAdminDashboardByYear = {
        ...state.getAdminDashboardByYear,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAdminDashboardByYearAction = {
    GETADMINDASHBOARDBYYEAR,
};

export { getAdminDashboardByYearAction };
export default getAdminDashboardByYearSlice.reducer;
export const {setInitialStateOfgetAdminDashboardByYear} = getAdminDashboardByYearSlice.actions
